module.exports = __webpack_public_path__ + "img/heaven_and_earth_box2.7eb35af9.png";